import { ImageWithFallback } from '@/components/molecules/ImageLoader/ImageLoader'
import { AppRoutes } from '@/routes'
import { LoadingOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import Link from 'next/link'
import React from 'react'
import { useNotificationsStore } from '@/store/notifications/notifications.store'
import styles from './MobileTopBar.module.scss'
import Chat from './assets/Chat.svg'
import Bell from './assets/Bell.svg'
import { createTariffsQueryOptions } from '@/features/Cards/queries'
import { useQuery } from '@tanstack/react-query'
import { createUserProfileQueryOptions } from '@/features/User/queries'

const SUPPORT_EMAIL = 'support@godefi.me'

export function MobileTopBar() {
  const isNewNotifications = useNotificationsStore((state) => state.isNewExists)

  const { data: tariffs, isError: isTariffsError } = useQuery(createTariffsQueryOptions())
  const userTariff = tariffs?.userTariff

  const { data: profile } = useQuery(createUserProfileQueryOptions())
  const avatar = profile?.profileImageUrl

  return (
    <Flex className={styles.root} align="center" justify="space-between">
      <Link href={AppRoutes.PROFILE_PAGE}>
        <Flex align="center" gap={10}>
          <ImageWithFallback className={styles.avatar} src={avatar} fallback="/icons/avatar.png" alt="Avatar" />
          <p className={styles.name}>Profile</p>
        </Flex>
      </Link>
      <Flex align="center" gap={22} className={styles.navs}>
        <Link href="/tariff/list" className={styles.premiumButtom}>
          {userTariff?.name || (isTariffsError ? 'Plans' : <LoadingOutlined spin />)}
        </Link>
        <Link href={AppRoutes.NOTIFICATIONS}>
          {isNewNotifications && (
            <span className={styles.newNotifications} />
          )}
          <Bell />
        </Link>
        <Link
          className={styles.chat}
          href="#"
          onClick={(e) => {
            e.preventDefault()
            const subject = `Support ticket - ${profile?.userId}`
            window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
          }}
        >
          <Chat />
        </Link>
      </Flex>
    </Flex>
  )
}
